import { useRecoilValue } from 'recoil';
import { sessionExpiredModalState } from '../../recoil/sessionModal/sessionModal.atom';
import { useRef } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';
import { useAuth } from '../../utils/hooks';

export const SessionModal = () => {
  const expiredModalOpen = useRecoilValue(sessionExpiredModalState);
  const { logOut } = useAuth();
  const initialRef = useRef(null);

  return (
    <Modal
      isOpen={expiredModalOpen}
      onClose={() => null}
      closeOnOverlayClick={false}
      initialFocusRef={initialRef}
      isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Session Expired</ModalHeader>
        <ModalBody>
          <Text>Please log in again to continue</Text>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => logOut()} ref={initialRef}>
            Log in again
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
